import Form from '@rjsf/core';

const DynamicForm = ({
    schema,
    uiSchema,
    formData,
    onSubmit,
    isLoading,
    submitBtnText,
    noHtml5Validate,
    showErrorList,
}) => {

    const handleSubmit = (data) => {
        if (data.formData) {
            const emptyTemplate = Object.fromEntries(
                Object.keys(schema.properties).map(key => [key, null])
            );
            const finalPayload = { ...emptyTemplate, ...data.formData };
            onSubmit(finalPayload);
        }
    };


    return (
        <div className='main-box p-4 mt-4'>

            <Form className="ml-3 mt-2 dynamic-form"
                schema={schema}
                uiSchema={uiSchema}
                formData={formData}
                onSubmit={handleSubmit}
                onError={(errors) => console.error("Validation errors:", errors)}
                noHtml5Validate={noHtml5Validate ?? true}
                showErrorList={showErrorList ?? false}
                disabled={isLoading}>
                <div className='text-center mt-4'>
                    <button type="submit"
                        disabled={isLoading}
                        className="btn btn-md primary-btn">
                        {submitBtnText}
                    </button>
                </div>
            </Form>
            <br />
        </div>
    )
}


export default DynamicForm;